import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHammerWench = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "hammer-wench" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.307,10.422,7.259,9.378A4.543,4.543,0,0,1,1.193,3.33L2.618,4.751A1.514,1.514,0,1,0,4.762,2.613L3.338,1.193A4.542,4.542,0,0,1,9.4,7.24l.97.967"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.319,13.136l1.422,1.418A4.543,4.543,0,0,1,22.807,20.6l-1.425-1.42a1.514,1.514,0,0,0-2.144,2.138l1.424,1.42A4.542,4.542,0,0,1,14.6,16.692l-1.422-1.418"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M1.445,22.6h0a2.233,2.233,0,0,1,0-3.167L6.14,14.747a.75.75,0,0,1,1.059,0l2.118,2.111a.746.746,0,0,1,0,1.056L4.621,22.6A2.251,2.251,0,0,1,1.445,22.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.586,1.188l6.221,6.2a1.489,1.489,0,0,1,0,2.111L20.69,11.612a1.5,1.5,0,0,1-2.118,0l-6.221-6.2a1.489,1.489,0,0,1,0-2.111l2.117-2.111A1.5,1.5,0,0,1,16.586,1.188Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.527,
			y1: 8.577,
			x2: 8.158,
			y2: 15.703
		})
	]
});
export default SvgHammerWench;
